import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map, shareReplay } from 'rxjs/operators'
import { AEMContentResponse } from 'src/app/models/aem-content-response.model'

@Injectable({
  providedIn: 'root',
})
export class AEMService {
  private readonly aemContentObservable: Observable<AEMContentResponse>
  public static readonly aemEndpoint = 'api/AEMContent'
  constructor(http: HttpClient) {
    this.aemContentObservable = http
      .get<AEMContentResponse>(AEMService.aemEndpoint)
      .pipe(shareReplay())
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getAEMContent(): Observable<any> {
    return this.aemContentObservable.pipe(
      map((appContent) => {
        appContent.isAEM = true
        return appContent
      }),
    )
  }
}
